import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
  };

  const BooksReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_books_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_books_success", (state,action) => {
        state.isLoading = false;
        state.Allbooks = action.payload.books;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_all_books_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_books_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_books_success", (state,action) => {
        state.isLoading = false;
        state.FillterBooks = action.payload.books;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_books_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_book_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_book_success", (state,action) => {
        state.isLoading = false;
        state.bookData = action.payload;
      })
      .addCase("get_book_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      });
  });
  
  export default BooksReducer;